export const configurationColumnTableLoads = {
  column1: true /*required field*/,
  column5: true /*required field*/,
  column4: true /*required field*/,
  column10: true,
  column11: true,
  column3: true,
  column2: true,
  fields: true,
  ph: true,
  sugar_level: true,
  acidity: true,
  mildew: true,
  density_raw_cherries: false,
  estimate_floats: false,
  estimate_cherries: false,
  estimate_greens: false,
  brix: false,
  product: false,
};
